module.exports = "/* @import \"https://use.fontawesome.com/releases/v5.2.0/css/all.css\"; */\n\n/* @import \"https://use.fontawesome.com/releases/v4.7.0/css/all.css\"; */\n\n/* @import \"https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta.3/css/bootstrap.min.css\"; */\n\n.card {\n    background-color: #183b78;\n}\n\n.card-body {\n    background-color: #25457e;\n}\n\n* {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/dashboard/dashboard.component.css
// module id = ./src/app/gerenciador/dashboard/dashboard.component.css
// module chunks = main